const MAX_DAY = 31;
const MAX_DAY_FIRST_DIGIT = parseInt(MAX_DAY.toString()[0]);
const MAX_MONTH = 12;
const MAX_MONTH_FIRST_DIGIT = parseInt(MAX_MONTH.toString()[0]);
const MIN_YEAR = 1900;
const MAX_YEAR = new Date().getUTCFullYear();

const _parseDay = (day) => {
    if (!day || day === '0') { return day; }
    if (isNaN(+day) || +day < 0 || +day > MAX_DAY) { return '0'; }
    if (+day > MAX_DAY_FIRST_DIGIT && day.length === 1) { return day.padStart(2, '0'); }
    return day;
}

const _parseMonth = (month) => {
    if (!month || month === '0') { return month; }
    if (isNaN(+month) || +month < 0 || +month > MAX_MONTH) { return '0'; }
    if (+month > MAX_MONTH_FIRST_DIGIT && month.length === 1) { return month.padStart(2, '0'); }
    return month;
}

const _parseYear = (year) => {
    if (!year) { return year; }
    year = year.substring(0, 4);
    if (isNaN(+year) || (year.length === 4 && +year <= MIN_YEAR)) { return MIN_YEAR.toString(); }
    if (+year > MAX_YEAR) { return MAX_YEAR.toString() }
    return year;
}

export const getDateFromInput = (input) => {
    let output = '';
    const separator = `\u200B.\u200B`;

    if (/\D\.$/.test(input)) input = input.substring(0, input.length - 3);

    let [ day, month, year ] = input
        .split('.')
        .map(seg => seg.replace(/\D/g, ''));

    day = _parseDay(day);
    month = _parseMonth(month);
    year = _parseYear(year);

    if (day && !month) {
        output = day.length === 2 ? day + separator : day;
    }
    if (day && month && !year) {
        output = month.length === 2 ? day + separator + month + separator : day + separator + month;
    }
    if (day && month && year) {
        output = (day + separator + month + separator + year).slice(0, 14);
    }
    return output;
}
